import type { ReactElement, SVGProps } from "react";

// Connectors — plug icon (replaces the 4-square apps grid; framing is now
// "things Bash connects to" rather than "apps you launch"). Route stays
// /apps for backwards-compat.
export function ConnectorsIcon(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M9 2v6" />
      <path d="M15 2v6" />
      <path d="M12 17v5" />
      <path d="M5 8h14" />
      <path d="M6 11V8h12v3a6 6 0 0 1-12 0Z" />
    </svg>
  );
}
